exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo-swatch-0[data-v-2acc9674]{fill:#006CE4;}\n.logo-swatch-1[data-v-2acc9674]{fill:#F0583B;}\n.logo-swatch-2[data-v-2acc9674]{fill:#B50097;}\n.logo-swatch-3[data-v-2acc9674]{fill:#FFCD49;}\n", ""]);

// exports
